import type { TutorialStep } from './createTutorial';
import { createTutorial } from './createTutorial';
import { LINKS } from '@/utils/links';

const TUTORIAL_KEY = 'tutorial_seen';

export const TUTORIAL_STEPS: TutorialStep[] = [
  {
    id: 'welcome',
    type: 'fullscreen',
    title: 'Bienvenue sur\nlibheros Pro',
    description:
      'Découvrez en quelques étapes comment tirer le meilleur parti de votre application.',
    showSkip: true,
  },
  {
    id: 'dashboard-notification',
    type: 'spotlight',
    target: '[data-tutorial="dashboard-notification"]',
    tab: LINKS.TABS.DASHBOARD,
    title: 'Notifications',
    description:
      'Soyez alerté en temps réel des nouvelles missions, messages et mises à jour importantes.',
    tooltipPosition: 'bottom',
  },
  {
    id: 'tab-profile',
    type: 'spotlight',
    target: '[data-tutorial="tab-profile"]',
    title: 'Profil',
    description:
      'Tenez à jour vos informations pour recevoir des offres pertinentes et pensez à activer vos notifications.',
    tooltipPosition: 'top',
  },
  {
    id: 'dashboard-appointments',
    type: 'spotlight',
    target: '[data-tutorial="dashboard-appointment-item"]',
    tab: LINKS.TABS.DASHBOARD,
    title: 'Mes rendez-vous',
    description: "Retrouvez votre planning du jour et vos prochains rendez-vous en un coup d'œil.",
    tooltipPosition: 'bottom',
    scrollTo: true,
  },
  {
    id: 'dashboard-offers',
    type: 'spotlight',
    target: '[data-tutorial="dashboard-offers"]',
    tab: LINKS.TABS.DASHBOARD,
    title: 'Missions & Demandes de soin',
    description:
      'Visualisez le nombre de missions et demandes de soin disponibles près de chez vous.',
    tooltipPosition: 'bottom',
    scrollTo: true,
  },
  {
    id: 'dashboard-infomed',
    type: 'spotlight',
    target: '[data-tutorial="dashboard-infomed-item"]',
    tab: LINKS.TABS.DASHBOARD,
    title: 'InfoMed',
    description:
      'Accédez directement aux dernières formations et fiches produits depuis votre tableau de bord.',
    tooltipPosition: 'bottom',
    scrollTo: true,
  },
  {
    id: 'dashboard-blog',
    type: 'spotlight',
    target: '[data-tutorial="dashboard-blog"]',
    tab: LINKS.TABS.DASHBOARD,
    title: 'Notre blog',
    description: 'Restez informé(e) avec les derniers articles et conseils du blog libheros.',
    tooltipPosition: 'top',
    scrollTo: true,
  },
  {
    id: 'tab-offers',
    type: 'spotlight',
    target: '[data-tutorial="offers-content"]',
    tab: '/tabs/offers',
    title: 'Missions & Demandes de soin',
    description:
      'Acceptez les missions et demandes de soin disponibles dans votre zone. De nouvelles offres arrivent régulièrement selon votre profil.',
    tooltipPosition: 'bottom',
    waitForLoad: true,
  },
  {
    id: 'demo-appointment-detail',
    type: 'page',
    tab: '/tabs/tutorial-appointment',
    title: "Détail d'un rendez-vous",
    description:
      'Consultez toutes les informations : date, lieu, type de soin et informations du patient. Ajoutez le rendez-vous à votre calendrier en un clic.',
  },
  {
    id: 'demo-slot-select',
    type: 'page',
    tab: '/tabs/tutorial-select-slots',
    title: 'Positionnez-vous sur une mission',
    description:
      'Sélectionnez un créneau disponible correspondant à vos disponibilités pour postuler à la mission.',
  },
  {
    id: 'tab-infomed',
    type: 'spotlight',
    target: '[data-tutorial="infomed-first-label"]',
    tab: '/tabs/infomed',
    title: 'Labels',
    description: 'Passez des labels pour développer vos compétences et votre visibilité.',
    tooltipPosition: 'bottom',
    waitForLoad: true,
  },
  {
    id: 'demo-infomed-resources',
    type: 'page',
    tab: '/tabs/infomed?tab=resources',
    title: 'Fiches produits & ressources',
    description:
      'Accédez à des fiches pratiques sur des prises en charge, des actes ou des produits et dispositifs médicaux.',
  },
  // TODO: Screening tool en cours de développement
  // {
  //   id: 'demo-infomed-screening',
  //   type: 'page',
  //   tab: '/tabs/infomed?tab=screening',
  //   title: 'Outils de screening',
  //   description:
  //     'Découvrez les recommandations officielles ou les projets de recherche en cours pour votre patientèle.',
  // },
  {
    id: 'profile-invoice',
    type: 'spotlight',
    target: '[data-tutorial="profile-facture"]',
    tab: '/tabs/profile',
    title: 'Facturation',
    description:
      'Gérez et consultez toutes vos factures directement depuis votre profil professionnel.',
    tooltipPosition: 'top',
    scrollTo: true,
  },
  {
    id: 'profile-help',
    type: 'spotlight',
    target: '[data-tutorial="profile-help"]',
    tab: '/tabs/profile',
    title: "Besoin d'aide ?",
    description: 'Ce bouton vous donne accès au support et à vos tutoriels à tout moment.',
    tooltipPosition: 'bottom',
    scrollTo: true,
  },
  {
    id: 'complete',
    type: 'fullscreen',
    title: 'Vous êtes prêt !',
    description: "Vous connaissez maintenant l'essentiel de libheros Pro. Bonne utilisation !",
  },
];

const tutorial = createTutorial(TUTORIAL_STEPS, TUTORIAL_KEY);

export const useTutorial = () => tutorial;

export type { TutorialStep };
